import Warning from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import { AlertTooltip } from '@openx/components-core/lib/AlertTooltip/AlertTooltip.tsx';
import type { JSX, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

const stopPropagation = (event: MouseEvent<HTMLSpanElement>) => event.stopPropagation();

export const ContextualSegmentsMisconfigurationAdornment = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    // The header row toggles the section, so the adornment must not act as a second toggle.
    <Box
      component="span"
      sx={{ display: 'inline-flex' }}
      onClick={stopPropagation}
      data-test="contextual-segments-misconfiguration-adornment"
    >
      <AlertTooltip
        color="warning.main"
        title={t('Some contextual segments will not deliver')}
        icon={<Warning fontSize="small" color="inherit" />}
      />
    </Box>
  );
};
